import { ClientDeviceNames, ServiceStatus } from "../types";
import { serviceToMadhiveSupplyCosts } from "./supplyCosts";
import { madhiveSupplyCostsToService } from "./supplyCosts";
import { inventoryPackagesToService, inventoryPackagesToServiceV2, serviceToInventoryPackages, serviceToInventoryPackagesV2 } from "./inventoryPackage";
import { inventoryMediaTypeToServiceInventoryMediaType, inventoryVideoTypeToServiceInventoryVideoType, serviceInventoryMediaTypeToInventoryMediaType, serviceInventoryVideoTypeToInventoryVideoType } from "./inventories";
export var ProductStatus;
(function (ProductStatus) {
    ProductStatus["DRAFT"] = "Draft";
    ProductStatus["READY"] = "Ready";
    ProductStatus["ARCHIVED"] = "Archived";
})(ProductStatus || (ProductStatus = {}));
export const productStatusToServiceStatus = (status) => {
    switch (status) {
        case ProductStatus.READY:
            return ServiceStatus.READY;
        case ProductStatus.DRAFT:
            return ServiceStatus.DRAFT;
        case ProductStatus.ARCHIVED:
            return ServiceStatus.ARCHIVED;
        default:
            return ServiceStatus.DRAFT;
    }
};
export const serviceStatusToProductStatus = (status) => {
    switch (status) {
        case ServiceStatus.READY:
            return ProductStatus.READY;
        case ServiceStatus.DRAFT:
            return ProductStatus.DRAFT;
        case ServiceStatus.ARCHIVED:
            return ProductStatus.ARCHIVED;
        default:
            return ProductStatus.DRAFT;
    }
};
export var ServiceProductDisplayType;
(function (ServiceProductDisplayType) {
    ServiceProductDisplayType["DT_NONE"] = "DT_NONE";
    ServiceProductDisplayType["DT_DOOH"] = "DT_DOOH";
    ServiceProductDisplayType["TRADITIONAL"] = "TRADITIONAL";
})(ServiceProductDisplayType || (ServiceProductDisplayType = {}));
export var ProductDisplayType;
(function (ProductDisplayType) {
    ProductDisplayType["DOOH"] = "DOOH";
    ProductDisplayType["TRADITIONAL"] = "Traditional";
})(ProductDisplayType || (ProductDisplayType = {}));
export const serviceProductDisplayTypeToProductDisplayType = (display_type) => {
    switch (display_type) {
        case ServiceProductDisplayType.DT_DOOH:
            return ProductDisplayType.DOOH;
        case ServiceProductDisplayType.TRADITIONAL:
            return ProductDisplayType.TRADITIONAL;
        default:
            return undefined;
    }
};
export const productDisplayTypeToServiceProductDisplayType = (displayType) => {
    switch (displayType) {
        case ProductDisplayType.DOOH:
            return ServiceProductDisplayType.DT_DOOH;
        case ProductDisplayType.TRADITIONAL:
            return ServiceProductDisplayType.TRADITIONAL;
        default:
            return ServiceProductDisplayType.DT_NONE;
    }
};
export const productToServiceProduct = (product) => {
    const inventory_packages = inventoryPackagesToService(product.inventoryPackages);
    const inventory_packages_v2 = inventoryPackagesToServiceV2(product.inventoryPackagesV2);
    const status = productStatusToServiceStatus(product.status);
    const media_type = inventoryMediaTypeToServiceInventoryMediaType(product.mediaType);
    const video_type = inventoryVideoTypeToServiceInventoryVideoType(product.videoType);
    const display_type = productDisplayTypeToServiceProductDisplayType(product.displayType);
    // don't include updated or updatedBy, as they'd be ignored on the backend anyway
    return {
        id: product.id,
        name: product.name.trim(),
        parent: product.parent,
        status,
        dayparts: product.dayparts,
        whitelist_id: product.whitelistId,
        device_caps: product.deviceCaps,
        // frontend does conversions from satoshis to dollars and back, and that sometimes added a nasty little decimal at the end
        // Ex: dollarsToSatoshis(32.011) --> 3201100000.0000005
        // ecpm caps at MAX_ECPM_DOLLARS (150) in dollars, so truncating here, on a figure represented in satoshis, is fine
        ecpm: Math.trunc(product.ecpm),
        vcr_target: product.vcrTarget,
        frequencies: product.frequencies,
        inventory_set: product.inventorySet,
        tentpole_inv_group_id: product.tentpoleInvGroupId,
        inventory_packages,
        inventory_packages_v2,
        ...madhiveSupplyCostsToService(product),
        media_type,
        video_type,
        display_type,
        optimization_template: product.optimizationTemplate,
        optimization_strategy: product.optimizationStrategy,
        is_legacy_product: product.isLegacyProduct
    };
};
export const serviceProductToProduct = (product) => {
    const inventoryPackages = serviceToInventoryPackages(product.inventory_packages);
    const inventoryPackagesV2 = serviceToInventoryPackagesV2(product.inventory_packages_v2);
    const status = serviceStatusToProductStatus(product.status);
    const mediaType = serviceInventoryMediaTypeToInventoryMediaType(product.media_type);
    const videoType = serviceInventoryVideoTypeToInventoryVideoType(product.video_type);
    const displayType = serviceProductDisplayTypeToProductDisplayType(product.display_type);
    return {
        id: product.id,
        name: product.name,
        parent: product.parent,
        updated: product.updated ? new Date(product.updated) : undefined,
        updatedBy: product.updated_by,
        status,
        dayparts: product.dayparts,
        whitelistId: product.whitelist_id,
        deviceCaps: {
            [ClientDeviceNames.CTV]: 0,
            [ClientDeviceNames.MOBILE]: 0,
            [ClientDeviceNames.DESKTOP]: 0,
            [ClientDeviceNames.TABLET]: 0,
            ...(product.device_caps || {})
        },
        ecpm: product.ecpm,
        vcrTarget: product.vcr_target,
        frequencies: product.frequencies || [],
        inventorySet: product.inventory_set,
        tentpoleInvGroupId: product.tentpole_inv_group_id,
        inventoryPackages,
        inventoryPackagesV2,
        ...serviceToMadhiveSupplyCosts(product),
        mediaType,
        videoType,
        displayType,
        optimizationTemplate: product.optimization_template,
        optimizationStrategy: product.optimization_strategy,
        isLegacyProduct: product.is_legacy_product
    };
};
//# sourceMappingURL=product.js.map